module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js!./ulip-qf.cfwidget.tsx"));
	}, "ulip");
}